import styled, { css, keyframes } from 'styled-components';

export const LoaderWrapper = styled.div<{ opacity?: string }>`
	z-index: 999;
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
	width: 100vw;
	background-color: ${({ opacity }) => `rgba(0, 0, 0, ${opacity || '0.5'})`};
	color: white;
`;

const spin = keyframes`
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
`;

export const Spinner = styled.div`
	border: 8px solid #f3f3f3;
	border-radius: 50%;
	border-top: ${({ theme }) => `8px solid ${theme.background.primary}}`};
	width: 80px;
	height: 80px;
	animation: ${spin} 1s linear infinite;
`;

export const Row = styled.div<{ center?: boolean }>`
	display: flex;
	flex-direction: row;

	${({ center }) =>
		center &&
		css`
			justify-content: center;
			align-items: center;
		`}

	&.full {
		gap: 1rem;
	}
`;

export const Column = styled.div`
	display: flex;
	flex-direction: column;

	&.full {
		gap: 1rem;
	}
`;

export const Table = styled.table<{ hover?: boolean }>`
	border: none;
	border-collapse: collapse;

	td,
	th {
		padding: 8px;
		border: 1px solid #ddd;
		text-align: center;
	}

	td.disabled {
		background-color: rgba(0, 0, 0, 0.1);
		cursor: not-allowed;
	}

	tbody tr {
		&:nth-of-type(odd) td:not([rowspan]) {
			background-color: #f2f2f2;
		}

		${({ hover }) =>
			hover &&
			css`
				&:hover {
					& > td:not(.disabled) {
						background-color: ${({ theme }) => theme.background.primaryAlpha};
					}

					& > td:not(.disabled) * {
						color: white;
					}

					td:has(input:focus) {
						outline: ${({ theme }) => `1px solid ${theme.background.primary}}`};
					}
				}
			`}

		td:has(input:focus) {
			outline: 1px solid #aaa;
		}
	}

	thead > tr {
		background-color: ${({ theme }) => theme.background.primary};
		color: white;
	}

	td:first-child {
		width: 200px;
	}

	td input,
	td [field-type='select'] {
		width: 100%;
		height: 100%;
		border: none;
		background-color: transparent;
		outline: none;
	}
`;

export const Dialog = styled.dialog`
	border: ${({ theme }) => `1px solid ${theme.background.primary}`};
	border-radius: 0.5rem;
	position: fixed;
	min-width: 30%;
	max-height: 85vh;
	top: 40%;
	left: 50%;
	transform: translate(-50%, -50%);
	box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);

	&::backdrop {
		background-color: rgba(0, 0, 0, 0.4);
	}
`;

export const DialogHeader = styled.div`
	padding: 0.5rem;
	border-bottom: ${({ theme }) => `1px solid ${theme.background.primary}`};
`;

export const DialogContent = styled.div`
	margin: 10px 0;
	padding: 1rem;
`;

export const DialogCta = styled.div`
	border-top: ${({ theme }) => `1px solid ${theme.background.primary}`};
	padding: 0.5rem;
	display: flex;
	justify-content: flex-end;
	gap: 1rem;
`;

export const CardContainer = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	gap: 1rem;
`;

export const Card = styled.div`
	border: ${({ theme }) => `1px solid ${theme.background.primary}`};
	border-radius: 0.5rem;
	padding: 5rem;

	transition: box-shadow 0.2s ease-in-out;

	&:hover {
		box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.2);
	}

	& > * {
		font-size: 1.15rem;
		font-weight: bold;
	}
`;
